import { Space, Typography } from "antd";
import React from "react";

const { Text } = Typography;

const Legend = ({ label, borderColor = "#000", background = "#000", circle }) => {
  return (
    <>
      <Space align="center" size={4} role="listitem">
        <div
          style={{
            width: 14,
            height: 14,
            borderRadius: circle ? "50%" : 4,
            border: `2px solid ${borderColor}`,
            backgroundColor: background,
            display: "flex",
            flex: "0 0 auto",
          }}
        />
        <Text className="legend-label">{label}</Text>
      </Space>
    </>
  );
};

export default Legend;
